import { render } from "./course-schema-editor.vue?vue&type=template&id=18ff5d1d&scoped=true"
import script from "./course-schema-editor.vue?vue&type=script&lang=ts"
export * from "./course-schema-editor.vue?vue&type=script&lang=ts"

import "./course-schema-editor.vue?vue&type=style&index=0&id=18ff5d1d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-18ff5d1d"

export default script